import axios, { AxiosResponse } from 'axios';
import { ILeiDetailData } from 'types/leiTypes';

const leiDetailApi = (varsym: string) => {
    return axios({
        method: 'GET',
        url: `LEI/${varsym}`
    }).then((resp: AxiosResponse<ILeiDetailData>) => resp.data);
};

export default leiDetailApi;
